import { PourbackReason } from "@/pages/caster/models/catalogs/pourback-reasons";
import { MESApiService } from "@dexteel/mesf-core";

export const getCatalogPourbackReasons = async () => {
	const apiService = new MESApiService();
	return await apiService.callV2("[STEEL].[GetCatalogPourbackReasons]", []);
};

export const upsertPourbackReason = async (data: PourbackReason) => {
	const apiService = new MESApiService();
	return await apiService.callV2("[STEEL].[UpsertPourbackReason]", [
		{ name: "PourbackReasonId", value: data.PourbackReasonId || null },
		{ name: "PourbackReasonName", value: data.PourbackReasonName },
		{ name: "IsActive", value: data.IsActive },
	]);
};

export const deletePourbackReason = async (pourbackReasonId: number) => {
	const apiService = new MESApiService();
	return await apiService.callV2("[STEEL].[DeletePourbackReason]", [
		{ name: "PourbackReasonId", value: pourbackReasonId },
	]);
};
